import { createContext } from 'react';
import { DefaultRouteHistoryValuesContextProps } from './route-history-types';

const DefaultHistoryContext = {
    pathHistory: {
        currentPath: '/',
        lastPath: null,
    }, 
    setPathHistory: () => {},
}

const RouteHistoryContext = createContext<DefaultRouteHistoryValuesContextProps>(DefaultHistoryContext);

export {
    RouteHistoryContext,
    DefaultHistoryContext,
};